<ng-form #form="ngForm">
  <account-edit-form-layout [source]="this"
    [sectionTitle]="'Preferred Store' | translate"
    [inFormTitle]="'Edit preferred store' | translate">
    <!-- prefix -->
    <input-wrap>
    <select class="input"
      name="preferred_store"
      [(ngModel)]="data.preferred_store"
      [muiInput]="'Preferred store'| translate">
      @for (option of options; track option) {
        <option
          [value]="option.value">
          {{option.label}}
        </option>
      }
    </select>
  </input-wrap>



</account-edit-form-layout>
</ng-form>